import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CrmPage } from './crm';
import {NgxPaginationModule} from 'ngx-pagination';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    CrmPage
  ],
  imports: [
    IonicPageModule.forChild(CrmPage),
    NgxPaginationModule,
    TranslateModule.forChild(),
    PipesModule
  ],
})
export class CrmPageModule {}



// WEBPACK FOOTER //
// ./src/pages/crm/crm.module.ts